import {Component, computed, signal} from '@angular/core'
import {PoliticallyExposedComponent} from '../../../form/118-politically-exposed/politically-exposed.component'

@Component({
  selector: 'spb-pep',
  templateUrl: './pep.component.html',
  imports: [
    PoliticallyExposedComponent
  ]
})
export class PepComponent {
  public model = signal(null)

  public valid = computed(() => this.model() !== null)
}
